// constants.js
// const BASE_URL = 'http://localhost:3000'; // Change this to your deployment URL when needed
// const BASE_URL = `http://127.0.0.1:8000/`;
const BASE_URL = `https://stemcity3d.com`;
export { BASE_URL };
 